import {
    apiRequest,
    masterWorkUnit,
    masterEmployeeStatus
} from "../../../../../services/adapters/kepegawaian/presensiService"

class IndexRepository {

    fetchWorkUnit = async (query) => {
        return await apiRequest("get", masterWorkUnit, {
            params: query
        }, true)
    }
    fetchEmployeeStatus = async (query) => {
        return await apiRequest("get", masterEmployeeStatus, {
            params: query
        }, true)
    }
    
}

export default IndexRepository